import React from "react";
import '../../styles/Footer.css';
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="content">
          <p className="text">
            © 2025 João Rafael Broz dos Santos <br/><a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" className="link" target="_blank" rel="noreferrer">CC BY-NC-ND 4.0 </a>
          </p>

        
        <div className="links">
          <Link to="/Sobre" className="link">Sobre</Link>
                 
        </div>
      </div>
    </footer>
  );
}